import React from 'react';
import { useNavigation } from '@react-navigation/native';

import {
	View,
} from 'react-native';

import {
	TypographyParagraph,
	Picker,
	SettingsRow,
	SettingsSection,
	SettingsSwitchRow,
} from '../../components';
import { confirmStockLevelsSortOptions, pickListSummarySortOptions } from '../../utils/sortMethods';
import { useUserContext } from '../../../common/utils';
import { getProductHealthComplianceLocalLabel } from '../../../common/utils/products/healthCompliance';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const PlanogramDetailFilterDialog = ({
	version,
	toggleDialogIsOpen,

	showAllSelections,
	hideImages,
	hideHealthCompliance,
	sortMethod,
	batchSameProduct,
	hidePickedItems,

	toggleShowAllSelections,
	toggleHideImages,
	toggleHideHealthCompliance,
	setSortMethod,
	toggleBatchSameProduct,
	toggleHidePickedItems,

	showAdvancedView,
	toggleShowAdvancedView,

	showSalesLastXDays,
	toggleShowSalesLastXDays,

	showSalesLastXDaysForPicklists,
	toggleShowSalesLastXDaysForPicklists,

	showPickOrderForPicklists,
	toggleShowPickOrderForPicklists,

	showQuantitySoldAfterRecalc,
	toggleShowQuantitySoldAfterRecalc,

	showExpiryDates,
	toggleShowExpiryDates,

	showExpiryDateButtons,
	toggleShowExpiryDateButtons,
}) => {
	const { tenantSettings, tenant } = useUserContext();
	const { planogramItemDaysSinceLastSale } = tenantSettings;
	const navigation = useNavigation();
	const styles = useThemedStyles(createStyles);

	const goToSettings = () => {
		toggleDialogIsOpen();
		navigation.push('SettingsView');
	};

	return (
		<View style={styles.optionsContainer}>
			<SettingsSection
				title="View settings"
				style={styles.section}
			>
				<SettingsRow label="Sort by">
					<Picker
						selectedValue={sortMethod || 'pickOrderAsc'}
						onValueChange={value => setSortMethod(value)}
						options={version.pickList ? pickListSummarySortOptions : confirmStockLevelsSortOptions}
						width={190}
					/>
				</SettingsRow>
				{
					version.showAllSelections && (
						<SettingsSwitchRow
							onValueChange={toggleShowAllSelections}
							value={showAllSelections}
							label="Show all selections"
						/>
					)
				}
				{
					version.batchProducts && (
						<SettingsSwitchRow
							onValueChange={toggleBatchSameProduct}
							label="Batch products"
							value={batchSameProduct}
						/>
					)
				}
				{
					version.hideImages && (
						<SettingsSwitchRow
							onValueChange={toggleHideImages}
							label="Hide images"
							value={hideImages}
						/>
					)
				}
				{
					version.hideHealthCompliance && (
						<SettingsSwitchRow
							onValueChange={toggleHideHealthCompliance}
							label={`Hide ${getProductHealthComplianceLocalLabel(tenant, true)}`}
							value={hideHealthCompliance}
						/>
					)
				}
				{
					version.hidePickedItems && (
						<SettingsSwitchRow
							onValueChange={toggleHidePickedItems}
							label="Hide picked items"
							value={hidePickedItems}
						/>
					)
				}
				{
					version.showAdvancedView && (
						<SettingsSwitchRow
							onValueChange={toggleShowAdvancedView}
							label="Show advanced view"
							value={showAdvancedView}
						/>
					)
				}
				{
					version.showSalesLastXDays && (
						<SettingsSwitchRow
							onValueChange={toggleShowSalesLastXDays}
							label={`Show sales last ${planogramItemDaysSinceLastSale} days`}
							value={showSalesLastXDays}
						/>
					)
				}
				{
					version.showSalesLastXDaysForPicklists && (
						<SettingsSwitchRow
							onValueChange={toggleShowSalesLastXDaysForPicklists}
							label={`Show sales last ${planogramItemDaysSinceLastSale} days`}
							value={showSalesLastXDaysForPicklists}
						/>
					)
				}
				{
					version.showPickOrderForPicklists && (
						<SettingsSwitchRow
							onValueChange={toggleShowPickOrderForPicklists}
							label="Show pick order"
							value={showPickOrderForPicklists}
						/>
					)
				}
				{
					version.showPickOrderForPicklists && (
						<SettingsSwitchRow
							onValueChange={toggleShowQuantitySoldAfterRecalc}
							label="Show quantity sold after recalculation"
							value={showQuantitySoldAfterRecalc}
						/>
					)
				}
				{
					tenantSettings.useExpiryDates && version.pickList && (
						<SettingsSwitchRow
							onValueChange={toggleShowExpiryDates}
							label="Show expiry dates"
							value={showExpiryDates}
						/>
					)
				}
				{
					tenantSettings.useExpiryDates && version.showExpiryDateButtons && (
						<SettingsSwitchRow
							onValueChange={toggleShowExpiryDateButtons}
							label="Show expiry date buttons"
							value={showExpiryDateButtons}
						/>
					)
				}
			</SettingsSection>
			<View style={styles.defaultsLinkRow}>
				<TypographyParagraph
					text="To change defaults, "
				/>
				<TypographyParagraph
					text="go to settings"
					href={true}
					onPress={goToSettings}
				/>
			</View>
		</View>
	);
};

const createStyles = ({ ui: { colors, space } }) => ({
	optionsContainer: {
		minWidth: 280,
	},
	section: {
		marginTop: 0,
	},
	defaultsLinkRow: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginTop: space.md,
		paddingTop: space.md,
		borderTopColor: colors.border,
		borderTopWidth: 1,
	},
});

export default PlanogramDetailFilterDialog;
